import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '@core/services/http/http.service';
import { HostConfigService } from '@core/services/host-config.service';
import { contextoSinCargaGlobal } from '@core/interceptors/carga-global/carga-global.interceptor';

export interface OrganizacionUsuario {
  orgId: string;
  nit: string | null;
  dv: string | null;
  urlLogo: string | null;
}

@Injectable()
export class OrganizacionesUsuarioService {
  private readonly http = inject(HttpService);
  private readonly hostConfig = inject(HostConfigService);

  public obtenerOrganizacionesUsuario(): Observable<OrganizacionUsuario[]> {
    const url = `${this.hostConfig.getCurrentBaseServiceUrl()}autorizacion/organizaciones`;
    return this.http.doGet<OrganizacionUsuario[]>(url, { context: contextoSinCargaGlobal() });
  }
}
